export const SCALAR_IO = '@scalar.io';
